// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ZoomInOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M15.5 14h-.79l-.28-.27a6.47 6.47 0 00-2.44-10.24 6.5 6.5 0 101.74 10.94l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0a4.5 4.5 0 11-.01-8.99A4.5 4.5 0 019.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2V7z","fill":"currentColor"}}]},"name":"zoom-in","theme":"outlined"};

const ZoomInOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ZoomInOutlinedSvg} />;
  ZoomInOutlined.displayName = 'ZoomInOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ZoomInOutlined);
